<template>
    <div class="apprentice-simple-card create-template">
        <design-2021-apprentice-data-table
            v-if="items.length >= 1"
            :fields="fields"
            :items="items">
            <template #options>
                <b-button
                    class="btn-add btn-add-template"
                    variant="primary"
                    @click="showCreateModal()">
                    {{ $t('templates.new_template') }}
                </b-button>
            </template>

            <template #cell(thumb)="rows">
                <div
                    class="magazine-templates-preview"
                    :class="!rows.item.thumb && 'no-thumb'">
                    <img
                        v-if="rows.item.thumb"
                        :src="rows.item.thumb" />
                </div>
            </template>

            <template #cell(full_cover)="rows">
                <div class="full_cover">
                    <b-form-checkbox
                        :value="rows.item.full_cover"
                        checked="1"
                        disabled
                        name="check-button"
                        switch
                        unchecked-value="0"></b-form-checkbox>
                </div>
            </template>

            <template #cell(actions)="rows">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-template"
                        v-b-tooltip.hover
                        :href="editTemplateUrl(rows.item.id)"
                        :title="$t('common.open')"
                        variant="primary-icon-only">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-template"
                        v-b-tooltip.hover
                        :title="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="delTemplate(rows.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-templates-list"
            v-else>
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                @click="showCreateModal()"
                :title="$t('templates.new_template')"></div>
            <div class="alert-notice">{{ $t('templates.no_templates_found') }}</div>
        </div>

        <b-modal
            v-model="template_modal"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            :ok-title="$t('common.save')"
            ok-variant="primary"
            size="md"
            :title="$t('templates.new_template')"
            @ok="submitTemplate">
            <div class="new-template">
                <b-form-group
                    :label="$t('common.title')"
                    label-for="template-title-input">
                    <b-form-input
                        id="template-title-input"
                        v-model="form.title"
                        :placeholder="$t('common.title')"
                        required>
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    label="Cover als spread:"
                    label-for="full-cover-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="full-cover-select"
                        v-model="form.full_cover"
                        :options="full_cover">
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    v-if="form.full_cover"
                    :label="$t('templates.version')"
                    label-for="full-cover-version-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="full-cover-version-select"
                        v-model="form.version"
                        :options="version">
                    </b-form-select>
                </b-form-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-template-component',
    props: ['templatesIn', 'categoryIn'],
    data() {
        return {
            templates: this.templatesIn,
            category: this.categoryIn,
            template_modal: false,
            form_new: true,
            form: {
                id: '',
                title: '',
                category_id: this.categoryIn.id,
                full_cover: 0,
                version: this.$t('templates.perfect'),
            },
            full_cover: [
                { text: 'Nee', value: 0 },
                { text: 'Ja', value: 1 },
            ],
            version: [
                {
                    text: this.$t('templates.perfect'),
                    value: this.$t('templates.perfect'),
                },
                { text: 'Hardbound', value: 'hardbound' },
            ],
            fields: [
                {
                    key: 'thumb',
                    label: 'Thumbnail',
                },
                {
                    key: 'title',
                    label: this.$t('common.title'),
                    sortable: true,
                },

                {
                    key: 'full_cover',
                    label: 'Cover als spread',
                    sortable: true,
                },

                {
                    key: 'version',
                    label: this.$t('templates.version'),
                    sortable: true,
                },

                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                    sortable: false,
                },
            ],
        };
    },

    methods: {
        editTemplateUrl(id) {
            return baseUrl + '/template/templates/edittemplate/' + id;
        },
        delTemplate(id) {
            this.alert
                .confirm(
                    this.$t('templates.delete_template'),
                    this.$t('templates.are_you_sure_you_want_to_delete_this_template'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(baseUrl + '/template/templates/delete/' + id).then(
                            (response) => {
                                this.templates = this.templates.filter((template) => template.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        showCreateModal() {
            this.resetForm();
            this.template_modal = true;
        },
        resetForm() {
            this.form.id = '';
            this.form.title = '';
            this.form.full_cover = 0;
            this.form.version = this.$t('templates.perfect');
            this.form_new = true;
        },
        submitTemplate() {
            this.alert.saving();

            if (this.form.id == '') {
                this.axios.post(baseUrl + '/template/templates/add', this.form).then((response) => {
                    this.template_modal = false;
                    this.resetForm();
                    this.templates.push(response.data.template);
                    this.alert.success();
                });
            } else {
                this.axios.post(baseUrl + '/template/templates/edit', this.form).then((response) => {
                    this.template_modal = false;
                    this.resetForm();
                    this.alert.success();
                });
            }
        },
    },

    computed: {
        items() {
            if (this.templates.length === 0) {
                return [];
            }

            return this.templates.map((template) => {
                return {
                    id: template.id,
                    title: template.title,
                    full_cover: template.full_cover,
                    version: template.version,
                    thumb: template.thumb_small,
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.magazine-templates-preview {
    img {
        height: 100px;
        width: 70px;
        object-fit: cover;
        object-position: center;
    }

    &.no-thumb {
        height: 100px;
        width: 70px;
        background-color: $secondary-background-color;
        color: $white;
        text-align: center;

        &:before {
            position: relative;
            font-size: 2rem;
            color: #fff;
            opacity: 0.8;
            content: '\F03E';
            font-weight: 900;
            font-family: 'Font Awesome 5 Pro';
            top: calc(50% - 16px);
        }
    }
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .btn-remove-template {
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
    }
}
</style>
